import SessionEventProto from "../session-event-proto";


export default class SessionEvent_DepartmentReset extends SessionEventProto {

    constructor(sessionEvent:any) {
        super(sessionEvent)
    }

    process() {

        gd.session.departments.reset(this.data)
    }
};



//
// var EventDepartmentReset = function(uid,data) {
//     this.data = data;
//     this.uid = uid;
// };
//
// EventDepartmentReset.prototype.validate = function(){
//     return true;
// };
//
// EventDepartmentReset.prototype.process = function(){
//     gd.session.departments.reset(this.data);
// }
//
// module.exports = EventDepartmentReset;
